import { MethodsEnum } from "../enums/Methods.ts";
import { Paciente } from "../models/Paciente.ts";
import handleService from "./apiService.ts";
import { emitirNotificacao } from "../contexts/NotificationContext.tsx";

const create = async (paciente: Paciente) => {
  // id nunca deve ser enviado num cadastro novo - o model usa 0 como placeholder,
  // mas o backend interpreta qualquer id nao-vazio como "use este id" (preparado
  // para a integracao Delphi), o que gera falso "id ja cadastrado" entre empresas.
  const { id, ...pacienteSemId } = paciente as any;
  const result = await handleService({
    method: MethodsEnum.POST,
    endpoint: "/paciente",
    data: pacienteSemId,
  });
  if (result?.data?.id) {
    emitirNotificacao({
      id: `cadastro-paciente-${result.data.id}`,
      tipo: "cadastro_paciente",
      titulo: "Novo paciente cadastrado",
      descricao: `${result.data.nome} foi adicionado ao cadastro de pacientes.`,
      link: "/paciente/listagem",
    });
  }
  return result;
};

const update = async (paciente) => {
  const result = await handleService({
    method: MethodsEnum.PATCH,
    endpoint: "/paciente/alterar",
    data: paciente,
  });
  return result;
};

const pacienteService = { create, update };

export default pacienteService;
